import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';

import {LocalStorageService} from './local-storage.service';

@Injectable()
export class LoginGuardService implements CanActivate {

  constructor(private localStorageService: LocalStorageService, private router: Router) {
  }

  canActivate(): boolean {
    if (this.localStorageService.getItem('bearer')) { // determine if the user is logged in from this method.
      return true;
    }
    this.router.navigate(['/dashboard']);
    return false;
  }
}
